// @flow

import {type RecordFactory, type RecordInstance, Map, Record} from 'immutable';

import type {RequestResponseMapType} from 'app/utils/redux_v2';
import {
  type ReceiveArticleFeedbackListType,
  RECEIVE_KB_ARTICLE_FEEDBACK,
} from '../actions';
import {type ArticleFeedbackType} from '../types';
import {setNormalizedList} from 'app/utils/redux_v2';

type ArticleFeedbackStateShape = RecordInstance<
  RequestResponseMapType<ArticleFeedbackType>
>;

export const ArticleFeedbackStateFactory: RecordFactory<ArticleFeedbackStateShape> =
  Record({
    byId: Map(),
    queries: Map(),
  });

export type RecordOfArticleFeedbackState =
  RecordInstance<ArticleFeedbackStateShape>;

export function articleFeedbackReducer(
  state: RecordOfArticleFeedbackState = ArticleFeedbackStateFactory(),
  action: ReceiveArticleFeedbackListType
): any {
  switch (action.type) {
    case RECEIVE_KB_ARTICLE_FEEDBACK: {
      return setNormalizedList(action.query, action.response, state);
    }

    default:
      return state;
  }
}
